import { isAxiosError } from 'axios';
import { SESSIONS_API } from './sessions';
import customAxios from '../axiosCustom';
import errorStatusCode from 'utils/errorStatusCode';

class SessionsService {
  read = async (uuid) => {
    try {
      const response = await customAxios.get(`${SESSIONS_API}/${uuid}`);

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const status = error.response?.status;

        switch (status) {
          case 401:
            throw new Error(errorStatusCode(401));

          default:
            throw new Error('Não foi possível carregar sessão');
        }
      }

      throw new Error(error);
    }
  };

  list = async (filter = '') => {
    try {
      const response = await customAxios.get(`${SESSIONS_API}${filter}`);

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const status = error.response?.status;

        switch (status) {
          case 401:
            throw new Error(errorStatusCode(401));

          default:
            throw new Error('Não foi possível listar sessões');
        }
      }

      throw new Error(error);
    }
  };

  create = async ({
    session_uuid,
    program_uuid,
    patient_uuid,
    supervisor_uuid,
    name,
    application_phase,
    status,
    procedure,
    criterion,
    materials,
    supervisor_name,
    suggested_reinforcer,
    attemps_number,
  }) => {
    try {
      const response = await customAxios.post(
        `${SESSIONS_API}/patient/${patient_uuid}`,
        {
          session_uuid,
          program_uuid,
          patient_uuid,
          supervisor_uuid,
          name,
          application_phase,
          status,
          procedure,
          criterion,
          materials,
          supervisor_name,
          suggested_reinforcer,
          attemps_number,
        }
      );

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const status = error.response.status;

        switch (status) {
          case 401:
            throw new Error(errorStatusCode(401));

          default:
            throw new Error('Não foi possível criar sessão');
        }
      }

      throw new Error(error);
    }
  };

  edit = async (
    uuid,
    {
      session_uuid,
      program_uuid,
      patient_uuid,
      supervisor_uuid,
      name,
      application_phase,
      status,
      procedure,
      criterion,
      materials,
      supervisor_name,
      suggested_reinforcer,
      attemps_number,
    }
  ) => {
    try {
      const response = await customAxios.put(`${SESSIONS_API}/${uuid}`, {
        session_uuid,
        program_uuid,
        patient_uuid,
        supervisor_uuid,
        name,
        application_phase,
        status,
        procedure,
        criterion,
        materials,
        supervisor_name,
        suggested_reinforcer,
        attemps_number,
      });

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const status = error.response.status;

        switch (status) {
          case 401:
            throw new Error(errorStatusCode(401));

          default:
            throw new Error('Não foi possível editar sessão');
        }
      }

      throw new Error(error);
    }
  };

  updateStatus = async ({ uuid, status }) => {
    try {
      const response = await customAxios.patch(`${SESSIONS_API}/${uuid}`, {
        status,
      });

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const status = error.response?.status;
        const defaultMsg = 'Não foi possível editar sessão';
        switch (status) {
          case 401:
            throw new Error(errorStatusCode(401));

          case 404:
            throw new Error(error.response?.data);

          case 422:
            throw new Error(error.response?.data);

          default:
            throw new Error(defaultMsg);
        }
      }

      throw new Error(error);
    }
  };

  delete = async (uuid) => {
    try {
      const response = await customAxios.delete(`${SESSIONS_API}/${uuid}`);

      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const status = error.response.status;

        switch (status) {
          case 401:
            throw new Error(errorStatusCode(401));

          default:
            throw new Error('Não foi possível apagar sessão');
        }
      }

      throw new Error(error);
    }
  };
}

export default new SessionsService();
